import { render, staticRenderFns } from "./RankingBuyu.vue?vue&type=template&id=47174c49&scoped=true&"
import script from "./RankingBuyu.vue?vue&type=script&lang=js&"
export * from "./RankingBuyu.vue?vue&type=script&lang=js&"
import style0 from "./RankingBuyu.vue?vue&type=style&index=0&id=47174c49&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47174c49",
  null
  
)

export default component.exports